"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ToggleColorScale = _interopRequireDefault(require("./components/ToggleColorScale"));
var _TogglePercentage = _interopRequireDefault(require("./components/TogglePercentage"));
var _ColumnManagement = _interopRequireDefault(require("./components/ColumnManagement"));
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["onApplyColorScale", "onCollapse", "onTogglePercentage", "columnMenuConfig"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var defaultMenuSlots = {
  columnMenuColumnsItem: null,
  columnMenuFilterItem: null,
  columnMenuSortItem: null,
  columnMenuPinningItem: null
};
var ColumnMenu = function ColumnMenu(_ref) {
  var onApplyColorScale = _ref.onApplyColorScale,
    onCollapse = _ref.onCollapse,
    onTogglePercentage = _ref.onTogglePercentage,
    columnMenuConfig = _ref.columnMenuConfig,
    props = _objectWithoutProperties(_ref, _excluded);
  var colDef = props.colDef;
  var slots = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultMenuSlots), colDef.withColorScale ? {
      columnMenuColorScaleItem: _ToggleColorScale["default"]
    } : null), colDef.withPercentage ? {
      columnMenuPercentageItem: _TogglePercentage["default"]
    } : null), colDef.pinnable || colDef.collapsible ? {
      columnMenuColumnsItem: _ColumnManagement["default"]
    } : null);
  }, [colDef]);
  var callbacksRef = (0, _react.useRef)(null);
  callbacksRef.current = {
    onApplyColorScale: onApplyColorScale,
    onCollapse: onCollapse,
    onTogglePercentage: onTogglePercentage
  };
  var slotProps = (0, _react.useMemo)(function () {
    return {
      columnMenuColorScaleItem: {
        onColorsScale: callbacksRef.current.onApplyColorScale,
        displayOrder: 0
      },
      columnMenuPercentageItem: {
        onToggle: callbacksRef.current.onTogglePercentage,
        displayOrder: 15
      },
      columnMenuColumnsItem: {
        onCollapse: callbacksRef.current.onCollapse,
        displayOrder: 30
      }
    };
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_xDataGridPro.GridColumnMenu, _objectSpread(_objectSpread({}, props), {}, {
    sx: {
      minWidth: 140,
      '& hr': {
        margin: '0 !important'
      },
      '& hr:last-child': {
        display: 'none'
      }
    },
    slots: slots,
    slotProps: slotProps
  }));
};
var _default = exports["default"] = ColumnMenu;